// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const hsa = {
  hsa: {
    contentful_name: 'HSA+ (DEFAULT DO NOT CHANGE)',
    button_text: {
      back: '查看健康计划',
      save: '保存缴费并继续',
      review: '继续查看',
      expensesPDF: '所有符合条件的费用 (PDF)',
      supplemental: '继续补充信息',
      balanceSubmit: '提交',
    },
    info_bar: '太好了,您已选择符合HSA资格的健康计划!',
    header: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '关于您的健康储蓄账户',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '您需要了解的一切',
              nodeType: 'text',
            },
          ],
          nodeType: 'heading-1',
        },
      ],
      nodeType: 'document',
    },
    section_cards: {
      faq: {
        tags: ['如何操作...', '如果...', 'HSA对比'],
        heading: '常见问题',
        subheading: '关于您的HSA的其他信息。',
      },
      about: {
        tags: ['基础知识', '承保费用'],
        heading: '了解您的福利',
        subheading: 'HSA如何帮助您和您的家人。',
      },
      longterm: {
        tags: ['HSA投资', '三重税收优惠'],
        heading: '为未来做准备',
        subheading: '了解您的HSA的长期规划。',
      },
      retirement: {
        tags: ['HSA投资', '退休目标'],
        heading: '如何使用我的HSA为退休储蓄?',
        subheading: '了解在HSA中储蓄更多资金如何帮助您为退休做准备。',
      },
      contributions: {
        tags: ['税收节省', '雇主缴款'],
        heading: '您的HSA缴款',
        subheading: {
          self: '保护自己免受自付费用的影响。',
          family: '保护您的家人免受自付费用的影响。',
        },
      },
    },
    open_hsa_question: {
      answerNo: '不,我没有HSA账户。',
      question: '您目前有健康储蓄账户吗?',
      answerYes: '是的,我有HSA账户!',
      noDescription:
        '别担心,HSA并不像看起来那么可怕。在本页面中,我们将介绍HSA为何有用、如何设置您的账户以及您应该存入多少金额。',
      yesDescription: '太好了!但让我们确保您向账户存入了足够的金额。我们会',
    },
    about_bubbles: {
      text: ['在您的账户中存入税前资金', '投资并增值这些资金', '支付符合条件的医疗保健费用'],
      icons: [
        'https://picwellapppublicdata.s3.amazonaws.com/contentful/hsaimages/piggy-bank.svg',
        'https://picwellapppublicdata.s3.amazonaws.com/contentful/hsaimages/chart.svg',
        'https://picwellapppublicdata.s3.amazonaws.com/contentful/hsaimages/about-heart.svg',
      ],
      title: '您的健康储蓄账户允许您...',
    },
    about_video: {
      link: 'https://vimeo.com/408084854',
      intro: '这里有一个简短的视频来解释:',
    },
    unused_funds: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '我会失去未使用的资金吗?',
              nodeType: 'text',
            },
          ],
          nodeType: 'heading-4',
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '不会!您的HSA账户中的资金',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold',
                },
              ],
              value: '永远归您所有',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ',即使您更换雇主也是如此。',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    triple_tax: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'HSA 为何如此强大?',
              nodeType: 'text',
            },
          ],
          nodeType: 'heading-4',
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'HSA 是一个**"三重税收优惠"**账户,这意味着您无需为 HSA 供款、收益或符合条件的支出提款缴纳任何税款。',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    catchup_info: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '由于您至少已满55岁,您可以向HSA额外缴纳{x}作为追加供款,以便为退休储蓄。',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    hsa_expenses_title: '哪些费用可以使用HSA资金支付?',
    hsa_expenses: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '医疗',
              nodeType: 'text',
            },
          ],
          nodeType: 'heading-6',
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '免赔额',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '处方药',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '非处方产品',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
          ],
          nodeType: 'unordered-list',
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '牙科',
              nodeType: 'text',
            },
          ],
          nodeType: 'heading-6',
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '洗牙',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'X光检查',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '正畸治疗',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
          ],
          nodeType: 'unordered-list',
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '视力',
              nodeType: 'text',
            },
          ],
          nodeType: 'heading-6',
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '年度检查',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '镜架和镜片',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '隐形眼镜',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
          ],
          nodeType: 'unordered-list',
        },
      ],
      nodeType: 'document',
    },
    contribution_question: {
      answerNo: '没有,我从未存入过',
      question: '您之前是否向健康储蓄账户(HSA)存入过资金?',
      answerYes: '是的,我之前存入过。',
      noDescription:
        'ALEX在这里为您提供帮助!向您的账户存入适当的金额非常重要,以确保您能够支付全年的自付费用。',
      yesDescription:
        '太棒了,您已经走在前面了!话虽如此,许多拥有健康储蓄账户的人并没有正确地向其存入资金。下面我们将确保您能够覆盖今年可能面临的任何风险。',
    },
    contribution_info: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '那么,我到底应该存入多少?',
              nodeType: 'text',
            },
          ],
          nodeType: 'heading-4',
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '至少,您应该计划存入足够的金额',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold',
                },
              ],
              value: '以支付您的平均自付费用估算',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ',但您存得越多,如果您的费用高于平均水平,您就会准备得越充分。',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '2022年HSA年度供款限额为',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ',因此在扣除您雇主供款',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: '后,您最多可以供款',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '{x}{x}',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: '。',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    catchup_addition: '+ $1,000追加补缴供款',
    slider_instruction: '移动下方滑块以调整您的捐款金额。',
    legend_terms: [
      {
        text: 'ALEX 估算您今年在医疗保健服务上的总支出金额,不包括任何保费。',
        type: 'oop',
        title: '自付费用估算',
        underline: '自付费用估算',
      },
      {
        text: '您的雇主将向您的健康储蓄账户(HSA)缴纳的金额。',
        type: 'employer',
        title: '雇主缴款',
        underline: '雇主',
      },
      {
        text: '您全年将缴纳的金额。',
        type: 'recommended',
        title: '您的缴款',
        underline: '您',
      },
      {
        text: '未通过健康储蓄账户(HSA)缴款覆盖的医疗费用估算金额。',
        type: 'remaining',
        title: '剩余费用',
        underline: '剩余',
      },
    ],
    contribution_data: {
      taxSavings: {
        text: '以下是您通过向健康储蓄账户(HSA)进行免税供款可以在联邦税上节省的金额。这基本上相当于免费的钱,您可以用它来帮助支付医疗保健费用,而不是交给政府。根据您的居住地,您还可能在州所得税上实现额外的节省。',
        underline: '税收节省',
      },
      perPaycheck: '每次工资',
      yearlyContribution: '年度供款',
    },
    risk_data: {
      text: '为了计算这个数字,我们将您的HSA供款与像您这样的人的自付费用进行比较。这个数字是像您这样的人中,最终费用低于您供款金额的人数百分比。这个数字越高,您就越有能力支付医疗账单。',
      underline: '我的储蓄够吗?',
      riskLevels: {
        safe: {
          tag: '安全',
          status: '太好了,您很安全!',
          explanation:
            '这个供款金额可以覆盖像您这样的人中{x}%的费用。您已经做好了充分准备来应对意外医疗账单,而且很有可能会有剩余资金可以为未来储蓄。',
        },
        risky: {
          tag: '有风险',
          status: '这有风险!',
          explanation:
            '这个供款金额只能覆盖像您这样的人中{x}%的费用。增加供款将提高您有足够储蓄来支付今年费用的可能性,并且可以为您节省更多税款。增加储蓄将提高您的财务安全性并节省更多税款。',
        },
        moderate: {
          tag: '中等',
          status: '还不错。',
          explanation:
            '这个供款金额可以覆盖像您这样的人中{x}%的费用。在正常年份,您应该有足够的资金来支付费用,但增加储蓄将使您更好地应对意外费用,并为您节省更多税款。',
        },
      },
    },
    investment_question: {
      answerNo: '没有,我还没有投资过资金。',
      question: '您之前投资过HSA账户资金吗?',
      answerYes: '是的,我正在投资HSA资金!',
      noDescription:
        '现在开始永远不会太晚!医疗保健是您退休后需要准备的最大开支之一,通过投资您的HSA资金,您可以利用复利和HSA的特殊税收优惠,确保您为这些开支做好准备。',
      yesDescription:
        '做得好!医疗保健费用昂贵,尤其是当您年纪大了以后。在HSA中储蓄和投资是为退休后的医疗保健费用做准备的最佳方式。您可以使用我们的预测工具来帮助确定您还需要储蓄多少才能支付退休后的医疗保健费用。',
    },
    long_term_header: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '如今退休的普通夫妇预计将花费约30万美元来支付退休后的医疗保健费用。',
              nodeType: 'text',
            },
          ],
          nodeType: 'heading-4',
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '医疗保健将是您退休后最大的开支之一,但通过HSA(健康储蓄账户)进行储蓄和投资是您为这些费用做准备的绝佳方式。事实上,它们是为退休后医疗保健费用储蓄的最佳方式!',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    triple_tax_header: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '让您的健康储蓄账户(HSA)为您服务!',
              nodeType: 'text',
            },
          ],
          nodeType: 'heading-3',
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '健康储蓄账户是一种非常好的退休储蓄方式,因为它们具有',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold',
                },
              ],
              value: '三重税收优势',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ':',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    triple_tax_bullets: [
      '您对健康储蓄账户(HSA)的任何供款都是免税的。',
      '您的资金可以通过投资实现免税增长。',
      '与401(k)不同,当您提取HSA资金时,如果您将这笔钱用于支付符合条件的医疗费用,则无需缴税。',
    ],
    picwell_disclaimer:
      '免责声明:ALEX估算假设HSA账户投资余额的固定回报率为6%。实际结果可能因市场表现而有所不同。',
    retirement_savings_info: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '我需要为退休储蓄多少钱?',
              nodeType: 'text',
            },
          ],
          nodeType: 'heading-4',
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '医疗保健将是您退休后最大的开支之一,但通过健康储蓄账户(HSA)进行储蓄和投资是帮助您为这些费用做好准备的绝佳方式。ALEX估计,像您这样年龄的人(65岁退休)在整个退休期间预计将在医疗保健相关费用上花费',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: '。',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '这是ALEX估算的您在典型Medicare计划中的保费和自付费用金额,假设您在65岁时退休并拥有平均预期寿命。此估算考虑了您的个人特征、居住地以及预期的医疗保健成本通货膨胀。',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '使用下方的预测工具,了解在HSA中增加储蓄如何帮助您为退休后的医疗保健费用做好准备。',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    current_hsa_info: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '您目前的HSA余额是多少?',
              nodeType: 'text',
            },
          ],
          nodeType: 'heading-4',
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '这里可以是大概数字。ALEX将使用此信息更好地描述您未来的储蓄情况。',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    current_hsa_balance_question: {
      header: '1. 您目前的HSA账户余额是多少?',
      description: '这里可以是大概的数额。',
    },
    persona_question: {
      header: '2. 以下哪项最能描述您如何使用HSA?',
      spender: {
        title: '消费者',
        description: '我使用HSA支付医疗账单,并储蓄剩余的资金。',
      },
      supersaver: {
        title: '超级储蓄者',
        description: '我将存入HSA的所有资金用于投资,并用其他资金支付医疗账单。',
      },
    },
    long_term_graph: {
      title: {
        text: 'ALEX通过估算您每年支付医疗账单后的剩余金额,并累计这些金额随时间的增长,来预测HSA储蓄。此估算假设您将这些额外储蓄进行投资,并获得6%的年回报率。',
        underline: '储蓄与目标对比',
      },
      labels: ['目标', '储蓄'],
      loadingText: '正在加载结果...',
    },
    retirement_data: {
      text: 'ALEX 通过将您预计的 HSA 余额除以您退休后预计的医疗保健费用来计算此百分比。已投资的 HSA 余额在退休后可能会继续增长,因此您不必达到 100% 就能做好充分准备。如果您更倾向于投资更保守的基金,或者预计退休后的医疗费用高于平均水平,则应设定更高的目标。费用增加可能来自多种因素,包括寿命超过平均水平或需要的医疗护理超过平均水平。',
      underline: '我为退休做好准备了吗?',
      riskLevels: {
        safe: {
          tag: '进度正常',
          status: '做得很好!',
          explanation:
            '有了这笔储蓄金额,您的状况相当不错。请记住,您的 HSA 投资在退休后将继续增长,这将帮助您支付费用。储蓄更多可以帮助您利用宝贵的税收优惠,为退休做更充分的准备。',
          bestExplanation:
            '实际上,您在 HSA 中储蓄再多也不为过。如果您在退休后需要在医疗保健上花费很多,您将做好充分准备;如果最终储蓄超过所需,也不用担心!用于非合格费用的 HSA 提款将被视为与 401(k) 提款相同。',
        },
        risky: {
          tag: '偏离进度',
          status: '您偏离了进度。',
          explanation:
            '按照这个储蓄水平,您的 HSA 可能不足以支付退休后的医疗保健费用。如果您能储蓄更多,就能利用宝贵的税收优惠来实现您的退休目标。',
        },
        moderate: {
          tag: '偏离进度',
          status: '快达到了!',
          explanation:
            '按照这个储蓄水平,您的 HSA 储蓄有可能无法支付退休后的所有医疗保健费用。如果您能储蓄更多,就能利用宝贵的税收优惠来实现您的退休目标。',
        },
      },
    },
    how_to_fa_qs: [
      {
        answer: '您可以通过福利管理平台开设HSA账户。您可以在审核页面上找到HSA管理平台的链接。',
        question: '如何开设HSA账户?',
      },
      {
        answer:
          '(1) 工资扣除 - 您的年度供款将被分成等额部分,并在税前从您的工资中扣除 (2) 使用您的HSA管理平台(链接在审核页面上)从您的支票账户或储蓄账户进行电子转账。',
        question: '如何向我的HSA账户供款?',
      },
      {
        answer:
          '当您开设HSA账户时,您将收到一张借记卡,可用于支付符合条件的医疗费用。您可以使用此借记卡直接向医疗保健提供者付款,也可以通过保险公司的网站提交这些付款。',
        question: '如何使用我的HSA资金?',
      },
      {
        answer:
          '当您开设HSA账户时,您将收到一张借记卡,可用于支付符合条件的医疗费用。您可以使用此借记卡直接向医疗保健提供者付款,也可以通过保险公司的网站提交这些付款。',
        question: '如何接收雇主的供款?',
      },
    ],
    chart_comparison_fa_qs: {
      hsaFsaHra: {
        cells: [
          ['账户中的资金归您所有', 'X', '', ''],
          ['账户中的资金归您的雇主所有', '', 'X', 'X'],
          ['您可以供款', 'X', 'X', ''],
          ['您的雇主可以供款', 'X', 'X', 'X'],
          ['必须拥有高免赔额计划才能供款', 'X', '', ''],
          ['您可以投资资金', 'X', '', ''],
        ],
        question: 'HSA、FSA、HRA:有什么区别?',
      },
      hsa401kIra: {
        cells: [
          ['供款免税', 'X', '401(k)供款不免除社会保障税和医疗保险税。', ''],
          ['资本利得免税', 'X', 'X', 'X'],
          ['提款免税', '如果用于合格医疗费用', '', '仅限罗斯IRA。'],
          ['最低分配要求', '', 'X', '罗斯IRA除外'],
        ],
        question: 'HSA、401(k)、IRA:有什么区别?',
      },
    },
    what_if_fa_qs: [
      {
        answer:
          '一旦您将资金存入HSA账户,即使您不再拥有高免赔额健康计划(HDHP)保障,该账户也可用于免税支付符合条件的医疗费用。但是,您将无法进行新的存款。',
        question: '如果我将来不参加符合HSA资格的计划会怎样?',
      },
      {
        answer:
          '即使您失业或离职,您HSA中的资金仍然属于您。您通常可以将这笔钱保留在前雇主的HSA中,或者将其转存到另一个HSA管理机构。',
        question: '如果我换工作或被解雇,我的HSA/资金会怎样?',
      },
      {
        answer:
          '一旦您年满65岁,无论您是否参加Medicare医疗保险,从HSA提取资金都不会受到罚款。如果您提取资金用于符合条件的医疗费用,则无需缴纳任何税款。HSA资金用于其他目的时将作为普通收入征税,就像401(k)提款一样。',
        question: '退休后我的HSA会怎样?',
      },
    ],
    next_text: {
      review: '接下来,我们将进行审核。',
      supplemental: '接下来,我们将选择补充计划。',
    },
    contribution_modal: {
      title: '贡献已保存',
      content: '我们已锁定您的贡献金额',
      disclaimer: '您可以随时返回更改此金额。',
    },
    eligible_expenses_pdf: 'https://picwellapppublicdata.s3.amazonaws.com/hsa-eligible-expenses.pdf',
    page_header: {
      text: 'HSA供款',
      subtext: '让我们确定您想要供款的金额。',
    },
    contribution_explainer: {
      contentful_name: '[DEFAULT] HSA Contribution Explainer',
      title: '您的HSA供款',
      header: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '每月至少贡献 ',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '{x}',
                marks: [
                  {
                    type: 'bold',
                  },
                  {
                    type: 'code',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: ' 或每年至少贡献 ',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '{x}',
                marks: [
                  {
                    type: 'bold',
                  },
                  {
                    type: 'code',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: ' 应该能够覆盖您预计的自付费用。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      employer_contribution: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '别忘了您的雇主将',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '为您的HSA账户贡献最高',
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: ' ',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '{x}',
                marks: [
                  {
                    type: 'bold',
                  },
                  {
                    type: 'code',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '!',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      employer_match: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '别忘了您的雇主将',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '匹配',
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '您的HSA供款的**',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '{x}',
                marks: [
                  {
                    type: 'code',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '****%',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: ',最高可达',
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '{x}',
                marks: [
                  {
                    type: 'code',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '**!',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      retirement_savings_cta: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '点击',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '退休健康储蓄账户',
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '选项卡,了解如何使用您的健康储蓄账户为退休后的医疗保健费用进行储蓄。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      continue: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '一旦您对捐款金额满意,请继续进入下一页。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      header_per_paycheck: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '至少贡献 ',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '{x}',
                marks: [
                  {
                    type: 'bold',
                  },
                  {
                    type: 'code',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: ' 或 ',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '{x}',
                marks: [
                  {
                    type: 'bold',
                  },
                  {
                    type: 'code',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: ' 应该能够覆盖您预计的自付费用。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      slider_cta: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '通过拖动下方的滑块来调整您的缴款金额。增加缴款以充分利用您的健康储蓄账户(HSA)!',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      hsa_administrator: '您的HSA管理机构是{name}。您可以通过访问{link}与他们联系。',
      hsa_administrator_website: 'HSA管理员网站',
      header_per_paycheck_max: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '缴纳最高额度**',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '{x}',
                marks: [
                  {
                    type: 'code',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '或',
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '{x}',
                marks: [
                  {
                    type: 'code',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: '**将有助于支付您预计的自付费用。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      slider_cta_max: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '通过拖动下方的滑块来调整您的捐款金额。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      hsa_balance_text: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '你的健康储蓄账户(HSA)中还有',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '{x}',
                marks: [
                  {
                    type: 'code',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value:
                  '的存款,但由于如果可以的话最好积累HSA资金,所以我不会将这笔钱计入你今年想要缴存的金额中。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
    },
    learn_more_modal_info: '了解HSA的基础知识、用途、常见问题等更多信息。',
    learn_more_modal_button_text: '了解更多',
    interactive_section: {
      contentful_name: '[DEFAULT] HSA Interactive Section',
      coverage_statistic: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                value: '这足以支付像您这样的人群中',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [],
                value: ' ',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [
                  {
                    type: 'bold',
                  },
                  {
                    type: 'code',
                  },
                ],
                value: '{x}',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                value: '****% 的费用。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      yearly_contribution_button: '年度捐款',
      yearly_contribution_chart_title: '年度贡献图表',
      yearly_chart_legend: [
        {
          text: '您的雇主将向您的健康储蓄账户(HSA)缴纳的金额。',
          type: 'employer',
          title: '雇主缴款',
          underline: '雇主',
        },
        {
          text: '您全年将缴纳的金额。',
          type: 'recommended',
          title: '您的缴款',
          underline: '您',
        },
        {
          text: '未通过健康储蓄账户缴款覆盖的医疗费用的估计金额。',
          type: 'remaining',
          title: '剩余费用',
          underline: '剩余',
        },
        {
          text: 'ALEX估计您今年将在医疗保健服务上花费的总金额,不包括任何保费。',
          type: 'oop',
          title: '自付费用估算',
          underline: '自付费用估算',
        },
      ],
      yearly_will_this_cover_question: '这能覆盖我的年度费用吗?',
      yearly_contribution: '年度捐款',
      yearly_tax_savings: '年度税收节省',
      yearly_coverage_detail_risky:
        '您可能需要储蓄更多资金来支付全年的开销。这将增强您的财务安全并节省更多税款。',
      yearly_coverage_detail_moderate: '增加储蓄将提高您的财务安全并节省更多税款。',
      yearly_coverage_detail_safe: '尽可能多地储蓄,直至达到上限,是增加您的保障和税收优惠的好方法。',
      per_paycheck_contribution: '每次工资扣款金额',
      retirement_savings_button: '健康储蓄账户用于退休',
      retirement_savings_chart_title: '退休储蓄图表',
      retirement_savings_chart_legend: [
        {
          text: '',
          type: 'projectedHsaBalance',
          title: '预计HSA余额',
          underline: '预计HSA余额',
        },
        {
          text: '',
          type: 'retirementHealthcareCosts',
          title: '退休医疗费用',
          underline: '退休医疗费用',
        },
      ],
      retirement_will_this_cover_question: '这能覆盖我的费用吗?',
      retirement_coverage_detail_risky:
        '您可能需要储蓄更多资金来支付开销。这将增强您的财务安全并节省更多税款。',
      retirement_coverage_detail_moderate: '增加储蓄将提高您的财务安全并节省更多税款。',
      retirement_coverage_detail_safe:
        '有了这笔储蓄,您的财务状况相当不错。请记住,您的健康储蓄账户(HSA)投资在退休后将继续增长。',
      current_hsa_balance: '当前HSA余额',
      usage_type: '使用类型',
      spender_persona: '支出者',
      super_saver_persona: '超级省钱',
      hsa_balance_question: '您目前的健康储蓄账户(HSA)余额是多少?',
      hsa_balance_question_approximation: '这里可以使用近似值。',
      persona_question: '以下哪项最能描述您如何使用健康储蓄账户(HSA)?',
      spender_persona_detail: '我使用健康储蓄账户(HSA)来支付医疗账单,并将剩余的钱存起来。',
      super_saver_persona_detail: '我将投入健康储蓄账户(HSA)的所有资金用于投资,并用其他资金支付医疗账单。',
      save_answers: '保存答案',
      policyholder_age_disclaimer: '对于年龄在{x}岁或以上的任何人,此预测基于单年医疗保健费用。',
      tooltips: {
        usage_type: {
          text: '设置此项以表示您计划如何使用您的健康储蓄账户(HSA)。',
          title: '使用类型',
        },
        yearly_tax_savings: {
          text: '这是您向健康储蓄账户供款所节省的预估税款。如果您未提供预估家庭收入,则使用最常见的边际税率进行计算。',
          title: '年度税款节省',
        },
        current_hsa_balance: {
          text: '如适用,请输入您现有的健康储蓄账户余额。',
          title: '当前健康储蓄账户余额',
        },
        yearly_contribution: {
          text: '这是您今年将供款的金额。',
          title: '年度供款',
        },
        per_paycheck_contribution: {
          text: '这是从每次工资中扣除的供款金额。',
          title: '每次工资供款',
        },
        yearly_will_this_cover_question_long_term: {
          text: 'ALEX预测您的预期供款是否能够覆盖您退休时的医疗保健费用。',
        },
        yearly_will_this_cover_question_short_term: {
          text: 'ALEX预测您的预期供款是否能够覆盖您今年的医疗保健费用。',
        },
      },
      accessibility: {
        edit_usage_type_button: '编辑使用类型',
        edit_hsa_balance_button: '编辑当前HSA余额',
        select_retirement_savings: '已选择退休储蓄标签页',
        select_yearly_contributions: '已选择年度缴款标签页',
      },
    },
    continue: '确认捐款金额无误后,请继续下一页。',
    ineligible_health_plan_text: '您选择的健康计划不符合HSA资格。',
    ineligible_health_plan_subtext: '请继续或选择其他健康计划。',
    unselected_health_plan_text: '您目前未选择任何健康计划。',
    unselected_health_plan_subtext: '请继续或选择其他健康计划。',
  },
};
